import { render, staticRenderFns } from "./MyQr.vue?vue&type=template&id=3173bc2e&scoped=true&"
import script from "./MyQr.vue?vue&type=script&lang=js&"
export * from "./MyQr.vue?vue&type=script&lang=js&"
import style0 from "./MyQr.vue?vue&type=style&index=0&id=3173bc2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3173bc2e",
  null
  
)

export default component.exports